export const TKeyProspectSearch = {
  PROSPECT_SEARCH_NAV: "PROSPECT_SEARCH_NAV",
  PROSPECT_SEARCH_TITLE: "PROSPECT_SEARCH_TITLE",
  PROSPECT_SEARCH_SUBTITLE: "PROSPECT_SEARCH_SUBTITLE",
  PROSPECT_CRITERIA_CONFIRM_TITLE: "PROSPECT_CRITERIA_CONFIRM_TITLE",
  PROSPECT_CRITERIA_REGENERATE_TITLE: "PROSPECT_CRITERIA_REGENERATE_TITLE",
  PROSPECT_CRITERIA_CONFIRM_NOTE: "PROSPECT_CRITERIA_CONFIRM_NOTE",
  PROSPECT_SEARCH_CARD_TITLE: "PROSPECT_SEARCH_CARD_TITLE",
  PROSPECT_SEARCH_CARD_DESCRIPTION: "PROSPECT_SEARCH_CARD_DESCRIPTION",
  PROSPECT_SEARCH_CARD_DESCRIPTION_MEMBER: "PROSPECT_SEARCH_CARD_DESCRIPTION_MEMBER",
  PROSPECT_SEARCH_CARD_CTA: "PROSPECT_SEARCH_CARD_CTA",
  PROSPECT_SEARCH_CARD_CTA_MEMBER: "PROSPECT_SEARCH_CARD_CTA_MEMBER",
  PROSPECT_SEARCH_SELECT_OFFER_LABEL: "PROSPECT_SEARCH_SELECT_OFFER_LABEL",
  PROSPECT_SEARCH_SELECT_AVATAR_LABEL: "PROSPECT_SEARCH_SELECT_AVATAR_LABEL",
  PROSPECT_SEARCH_STRATEGY_TITLE: "PROSPECT_SEARCH_STRATEGY_TITLE",
  PROSPECT_SEARCH_GENERATE_CRITERIA_CTA: "PROSPECT_SEARCH_GENERATE_CRITERIA_CTA",
  PROSPECT_SEARCH_REGENERATE_CRITERIA_CTA: "PROSPECT_SEARCH_REGENERATE_CRITERIA_CTA",
  PROSPECT_SEARCH_CRITERIA_DESCRIPTION: "PROSPECT_SEARCH_CRITERIA_DESCRIPTION",
  PROSPECT_SEARCH_CRITERIA_DESCRIPTION_MEMBER: "PROSPECT_SEARCH_CRITERIA_DESCRIPTION_MEMBER",
  PROSPECT_SEARCH_AVATAR_UPDATED: "PROSPECT_SEARCH_AVATAR_UPDATED",
  PROSPECT_SEARCH_GENERATING: "PROSPECT_SEARCH_GENERATING",
  PROSPECT_SEARCH_COLLAPSE: "PROSPECT_SEARCH_COLLAPSE",
  PROSPECT_SEARCH_LIST_TITLE: "PROSPECT_SEARCH_LIST_TITLE",
  PROSPECT_SEARCH_ORDER_PENDING: "PROSPECT_SEARCH_ORDER_PENDING",
  PROSPECT_SEARCH_FIND_CTA: "PROSPECT_SEARCH_FIND_CTA",
  PROSPECT_SEARCH_FILTER_EMPTY: "PROSPECT_SEARCH_FILTER_EMPTY",
  PROSPECT_SEARCH_FILTER_ALL: "PROSPECT_SEARCH_FILTER_ALL",
  PROSPECT_SEARCH_FILTER_NEW: "PROSPECT_SEARCH_FILTER_NEW",
  PROSPECT_SEARCH_FILTER_QUALIFIED: "PROSPECT_SEARCH_FILTER_QUALIFIED",
  PROSPECT_SEARCH_FILTER_REJECTED: "PROSPECT_SEARCH_FILTER_REJECTED",
  PROSPECT_SEARCH_ADD_MANUAL_CTA: "PROSPECT_SEARCH_ADD_MANUAL_CTA",
  PROSPECT_SEARCH_ADD_MANUAL_TITLE: "PROSPECT_SEARCH_ADD_MANUAL_TITLE",
  PROSPECT_SEARCH_EMPTY_TITLE: "PROSPECT_SEARCH_EMPTY_TITLE",
  PROSPECT_SEARCH_EMPTY_TEXT: "PROSPECT_SEARCH_EMPTY_TEXT",
  PROSPECT_SEARCH_EMPTY_PENDING_TITLE: "PROSPECT_SEARCH_EMPTY_PENDING_TITLE",
  PROSPECT_SEARCH_EMPTY_PENDING_TEXT: "PROSPECT_SEARCH_EMPTY_PENDING_TEXT",
  PROSPECT_ORDERS_TITLE: "PROSPECT_ORDERS_TITLE",
  PROSPECT_ORDERS_EMPTY: "PROSPECT_ORDERS_EMPTY",
  PROSPECT_ORDER_PLACED_ON: "PROSPECT_ORDER_PLACED_ON",
  PROSPECT_ORDER_STATUS_PENDING: "PROSPECT_ORDER_STATUS_PENDING",
  PROSPECT_ORDER_STATUS_IN_PROGRESS: "PROSPECT_ORDER_STATUS_IN_PROGRESS",
  PROSPECT_ORDER_STATUS_COMPLETED: "PROSPECT_ORDER_STATUS_COMPLETED",
  PROSPECT_ORDER_TITLE: "PROSPECT_ORDER_TITLE",
  PROSPECT_ORDER_COST: "PROSPECT_ORDER_COST",
  PROSPECT_ORDER_COST_ONE: "PROSPECT_ORDER_COST_ONE",
  PROSPECT_ORDER_UNIT_PROSPECTS: "PROSPECT_ORDER_UNIT_PROSPECTS",
  PROSPECT_ORDER_UNIT_PROSPECT: "PROSPECT_ORDER_UNIT_PROSPECT",
  PROSPECT_ORDER_CREDIT_SINGULAR: "PROSPECT_ORDER_CREDIT_SINGULAR",
  PROSPECT_ORDER_CREDIT_PLURAL: "PROSPECT_ORDER_CREDIT_PLURAL",
  PROSPECT_ORDER_REFUND_INFO: "PROSPECT_ORDER_REFUND_INFO",
  PROSPECT_ORDER_MAIL_INFO: "PROSPECT_ORDER_MAIL_INFO",
  PROSPECT_ORDER_CONFIRM: "PROSPECT_ORDER_CONFIRM",
  PROSPECT_ORDER_ERROR: "PROSPECT_ORDER_ERROR",
  PROSPECT_DETAIL_TAB_CONTEXT: "PROSPECT_DETAIL_TAB_CONTEXT",
  PROSPECT_DETAIL_CONTEXT_EMPTY_TITLE: "PROSPECT_DETAIL_CONTEXT_EMPTY_TITLE",
  PROSPECT_DETAIL_CONTEXT_EMPTY: "PROSPECT_DETAIL_CONTEXT_EMPTY",
  PROSPECT_DETAIL_CONTEXT_EMPTY_INSTALL: "PROSPECT_DETAIL_CONTEXT_EMPTY_INSTALL",
  PROSPECT_DETAIL_CONTEXT_UPDATED: "PROSPECT_DETAIL_CONTEXT_UPDATED",
  PROSPECT_SEARCH_COL_PROFILE: "PROSPECT_SEARCH_COL_PROFILE",
  PROSPECT_SEARCH_COL_SIGNALS: "PROSPECT_SEARCH_COL_SIGNALS",
  PROSPECT_SEARCH_COL_SCORE: "PROSPECT_SEARCH_COL_SCORE",
  PROSPECT_SEARCH_GROUP_CRITERIA: "PROSPECT_SEARCH_GROUP_CRITERIA",
  PROSPECT_SEARCH_GROUP_SIGNALS: "PROSPECT_SEARCH_GROUP_SIGNALS",
  PROSPECT_SEARCH_GROUP_EXCLUSIONS: "PROSPECT_SEARCH_GROUP_EXCLUSIONS",
  PROSPECT_SEARCH_GROUP_PLATFORMS: "PROSPECT_SEARCH_GROUP_PLATFORMS",
  PROSPECT_SEARCH_NO_AVATAR_TITLE: "PROSPECT_SEARCH_NO_AVATAR_TITLE",
  PROSPECT_SEARCH_NO_AVATAR_TITLE_MEMBER: "PROSPECT_SEARCH_NO_AVATAR_TITLE_MEMBER",
  PROSPECT_SEARCH_NO_AVATAR_BADGE: "PROSPECT_SEARCH_NO_AVATAR_BADGE",
  PROSPECT_SEARCH_NO_AVATAR_DESCRIPTION: "PROSPECT_SEARCH_NO_AVATAR_DESCRIPTION",
  PROSPECT_SEARCH_NO_AVATAR_DESCRIPTION_MEMBER: "PROSPECT_SEARCH_NO_AVATAR_DESCRIPTION_MEMBER",
  PROSPECT_SEARCH_NO_AVATAR_BUTTON: "PROSPECT_SEARCH_NO_AVATAR_BUTTON",
  PROSPECT_SEARCH_NO_AVATAR_BUTTON_MEMBER: "PROSPECT_SEARCH_NO_AVATAR_BUTTON_MEMBER",
  PROSPECT_SEARCH_CRITERIA_TARGET_ROLES: "PROSPECT_SEARCH_CRITERIA_TARGET_ROLES",
  PROSPECT_SEARCH_CRITERIA_TARGET_SENIORITIES: "PROSPECT_SEARCH_CRITERIA_TARGET_SENIORITIES",
  PROSPECT_SEARCH_CRITERIA_TARGET_FUNCTIONS: "PROSPECT_SEARCH_CRITERIA_TARGET_FUNCTIONS",
  PROSPECT_SEARCH_CRITERIA_TARGET_INDUSTRIES: "PROSPECT_SEARCH_CRITERIA_TARGET_INDUSTRIES",
  PROSPECT_SEARCH_CRITERIA_TARGET_BUSINESS_MODELS:
    "PROSPECT_SEARCH_CRITERIA_TARGET_BUSINESS_MODELS",
  PROSPECT_SEARCH_CRITERIA_TARGET_COMPANY_STAGES: "PROSPECT_SEARCH_CRITERIA_TARGET_COMPANY_STAGES",
  PROSPECT_SEARCH_CRITERIA_TARGET_COMPANY_SIZES: "PROSPECT_SEARCH_CRITERIA_TARGET_COMPANY_SIZES",
  PROSPECT_SEARCH_CRITERIA_TARGET_TECHNOLOGIES: "PROSPECT_SEARCH_CRITERIA_TARGET_TECHNOLOGIES",
  PROSPECT_SEARCH_CRITERIA_TARGET_COMPANIES: "PROSPECT_SEARCH_CRITERIA_TARGET_COMPANIES",
  PROSPECT_SEARCH_CRITERIA_TARGET_LOCATIONS: "PROSPECT_SEARCH_CRITERIA_TARGET_LOCATIONS",
  PROSPECT_SEARCH_CRITERIA_SEARCH_KEYWORDS: "PROSPECT_SEARCH_CRITERIA_SEARCH_KEYWORDS",
  PROSPECT_SEARCH_CRITERIA_SEARCH_QUERIES: "PROSPECT_SEARCH_CRITERIA_SEARCH_QUERIES",
  PROSPECT_SEARCH_CRITERIA_MUST_HAVE_SIGNALS: "PROSPECT_SEARCH_CRITERIA_MUST_HAVE_SIGNALS",
  PROSPECT_SEARCH_CRITERIA_PREFERRED_SIGNALS: "PROSPECT_SEARCH_CRITERIA_PREFERRED_SIGNALS",
  PROSPECT_SEARCH_CRITERIA_PAIN_SIGNALS: "PROSPECT_SEARCH_CRITERIA_PAIN_SIGNALS",
  PROSPECT_SEARCH_CRITERIA_TRIGGER_SIGNALS: "PROSPECT_SEARCH_CRITERIA_TRIGGER_SIGNALS",
  PROSPECT_SEARCH_CRITERIA_TRUST_SIGNALS: "PROSPECT_SEARCH_CRITERIA_TRUST_SIGNALS",
  PROSPECT_SEARCH_CRITERIA_EXCLUDE_SIGNALS: "PROSPECT_SEARCH_CRITERIA_EXCLUDE_SIGNALS",
  PROSPECT_SEARCH_CRITERIA_EXCLUDE_KEYWORDS: "PROSPECT_SEARCH_CRITERIA_EXCLUDE_KEYWORDS",
  PROSPECT_SEARCH_CRITERIA_EXCLUDE_COMPANIES: "PROSPECT_SEARCH_CRITERIA_EXCLUDE_COMPANIES",
  PROSPECT_SEARCH_CRITERIA_RECOMMENDED_PLATFORMS: "PROSPECT_SEARCH_CRITERIA_RECOMMENDED_PLATFORMS",
  PROSPECT_SEARCH_QUALIFY: "PROSPECT_SEARCH_QUALIFY",
  PROSPECT_SEARCH_REJECT: "PROSPECT_SEARCH_REJECT",
  PROSPECT_SEARCH_STATUS_QUALIFIED: "PROSPECT_SEARCH_STATUS_QUALIFIED",
  PROSPECT_SEARCH_STATUS_REJECTED: "PROSPECT_SEARCH_STATUS_REJECTED",
  PROSPECT_SEARCH_REJECT_TITLE: "PROSPECT_SEARCH_REJECT_TITLE",
  PROSPECT_SEARCH_REJECT_INFO: "PROSPECT_SEARCH_REJECT_INFO",
  PROSPECT_SEARCH_REJECT_REASON_LABEL: "PROSPECT_SEARCH_REJECT_REASON_LABEL",
  PROSPECT_SEARCH_REJECT_REASON_PLACEHOLDER: "PROSPECT_SEARCH_REJECT_REASON_PLACEHOLDER",
  PROSPECT_SEARCH_REJECT_CONFIRM: "PROSPECT_SEARCH_REJECT_CONFIRM",
  PROSPECT_SEARCH_QUALIFY_TITLE: "PROSPECT_SEARCH_QUALIFY_TITLE",
  PROSPECT_SEARCH_QUALIFY_INFO: "PROSPECT_SEARCH_QUALIFY_INFO",
  PROSPECT_SEARCH_QUALIFY_REASON_PLACEHOLDER: "PROSPECT_SEARCH_QUALIFY_REASON_PLACEHOLDER",
  PROSPECT_SEARCH_QUALIFY_CONFIRM: "PROSPECT_SEARCH_QUALIFY_CONFIRM",
  PROSPECT_SOURCE_MEIDLY_TITLE: "PROSPECT_SOURCE_MEIDLY_TITLE",
  PROSPECT_SOURCE_MEIDLY_BADGE: "PROSPECT_SOURCE_MEIDLY_BADGE",
  PROSPECT_SOURCE_MEIDLY_DESC: "PROSPECT_SOURCE_MEIDLY_DESC",
  PROSPECT_SOURCE_MEIDLY_BENEFIT_1: "PROSPECT_SOURCE_MEIDLY_BENEFIT_1",
  PROSPECT_SOURCE_MEIDLY_BENEFIT_2: "PROSPECT_SOURCE_MEIDLY_BENEFIT_2",
  PROSPECT_SOURCE_MEIDLY_BENEFIT_3: "PROSPECT_SOURCE_MEIDLY_BENEFIT_3",
  PROSPECT_SOURCE_LINKEDIN_TITLE: "PROSPECT_SOURCE_LINKEDIN_TITLE",
  PROSPECT_SOURCE_LINKEDIN_BADGE: "PROSPECT_SOURCE_LINKEDIN_BADGE",
  PROSPECT_SOURCE_LINKEDIN_DESC: "PROSPECT_SOURCE_LINKEDIN_DESC",
  PROSPECT_SOURCE_LINKEDIN_BENEFIT_1: "PROSPECT_SOURCE_LINKEDIN_BENEFIT_1",
  PROSPECT_SOURCE_LINKEDIN_BENEFIT_2: "PROSPECT_SOURCE_LINKEDIN_BENEFIT_2",
  PROSPECT_SOURCE_LINKEDIN_BENEFIT_3: "PROSPECT_SOURCE_LINKEDIN_BENEFIT_3",
  PROSPECT_SOURCE_LINKEDIN_EXTRACT_CTA: "PROSPECT_SOURCE_LINKEDIN_EXTRACT_CTA",
  PROSPECT_SOURCE_LINKEDIN_SEARCH_CTA: "PROSPECT_SOURCE_LINKEDIN_SEARCH_CTA",
  PROSPECT_SOURCE_LINKEDIN_ANALYZING: "PROSPECT_SOURCE_LINKEDIN_ANALYZING",
  IMPORTED_PROFILES_LIST_EMPTY: "IMPORTED_PROFILES_LIST_EMPTY",
  IMPORTED_PROFILES_TAB_IMPORTED: "IMPORTED_PROFILES_TAB_IMPORTED",
  IMPORTED_PROFILES_TAB_ANALYZED: "IMPORTED_PROFILES_TAB_ANALYZED",
  IMPORTED_PROFILES_TAB_POTENTIAL: "IMPORTED_PROFILES_TAB_POTENTIAL",
  IMPORTED_PROFILES_ANALYZED_EMPTY: "IMPORTED_PROFILES_ANALYZED_EMPTY",
  IMPORTED_PROFILES_POTENTIAL_EMPTY: "IMPORTED_PROFILES_POTENTIAL_EMPTY",
  IMPORTED_PROFILES_TAB_REJECTED: "IMPORTED_PROFILES_TAB_REJECTED",
  IMPORTED_PROFILES_REJECTED_EMPTY: "IMPORTED_PROFILES_REJECTED_EMPTY",
  IMPORTED_PROFILE_VIEW_PROFILE: "IMPORTED_PROFILE_VIEW_PROFILE",
  PROSPECT_STAT_REJECTED: "PROSPECT_STAT_REJECTED",
  PROSPECT_STAT_ORDERS: "PROSPECT_STAT_ORDERS",
  PROSPECT_STAT_FOUND: "PROSPECT_STAT_FOUND",
  PROSPECT_STAT_AVG_SCORE: "PROSPECT_STAT_AVG_SCORE",
  PROSPECT_STAT_IMPORTED: "PROSPECT_STAT_IMPORTED",
  PROSPECT_POOL_BUTTON_SEARCH: "PROSPECT_POOL_BUTTON_SEARCH",
  PROSPECT_POOL_DISABLED_NO_KEYWORDS: "PROSPECT_POOL_DISABLED_NO_KEYWORDS",
  PROSPECT_POOL_DISABLED_NOTHING_NEW: "PROSPECT_POOL_DISABLED_NOTHING_NEW",
  PROSPECT_POOL_MODAL_TITLE: "PROSPECT_POOL_MODAL_TITLE",
  PROSPECT_POOL_MODAL_TEXT: "PROSPECT_POOL_MODAL_TEXT",
  PROSPECT_POOL_KEYWORDS: "PROSPECT_POOL_KEYWORDS",
  PROSPECT_POOL_KEYWORDS_MORE: "PROSPECT_POOL_KEYWORDS_MORE",
  PROSPECT_POOL_MODAL_FOUND: "PROSPECT_POOL_MODAL_FOUND",
  PROSPECT_POOL_UNIT: "PROSPECT_POOL_UNIT",
  PROSPECT_POOL_STEP_LESS: "PROSPECT_POOL_STEP_LESS",
  PROSPECT_POOL_STEP_MORE: "PROSPECT_POOL_STEP_MORE",
  PROSPECT_POOL_MODAL_EMPTY: "PROSPECT_POOL_MODAL_EMPTY",
  PROSPECT_POOL_MODAL_EMPTY_HINT: "PROSPECT_POOL_MODAL_EMPTY_HINT",
  PROSPECT_POOL_SCANNING: "PROSPECT_POOL_SCANNING",
  PROSPECT_POOL_CARRY_OVER: "PROSPECT_POOL_CARRY_OVER",
  PROSPECT_POOL_CONFIRM_TITLE: "PROSPECT_POOL_CONFIRM_TITLE",
  PROSPECT_POOL_CONFIRM_DESC: "PROSPECT_POOL_CONFIRM_DESC",
  PROSPECT_POOL_CONFIRM_CTA: "PROSPECT_POOL_CONFIRM_CTA",
  PROSPECT_STAT_POTENTIAL_KEYWORD: "PROSPECT_STAT_POTENTIAL_KEYWORD",
  PROSPECT_STAT_POTENTIAL_AI: "PROSPECT_STAT_POTENTIAL_AI",
  IMPORTED_PROFILE_ANALYSIS_AI_DESC: "IMPORTED_PROFILE_ANALYSIS_AI_DESC",
  IMPORTED_PROFILE_ANALYSIS_TITLE: "IMPORTED_PROFILE_ANALYSIS_TITLE",
  IMPORTED_PROFILE_ANALYSIS_DEEP_DESC: "IMPORTED_PROFILE_ANALYSIS_DEEP_DESC",
  IMPORTED_PROFILE_ANALYSIS_DEEP_COST: "IMPORTED_PROFILE_ANALYSIS_DEEP_COST",
  IMPORTED_PROFILE_ANALYSIS_DEEP_UNIT: "IMPORTED_PROFILE_ANALYSIS_DEEP_UNIT",
  IMPORTED_PROFILE_ANALYSIS_DEEP_AVAILABLE: "IMPORTED_PROFILE_ANALYSIS_DEEP_AVAILABLE",
  IMPORTED_PROFILE_ANALYSIS_CHOICE_TITLE: "IMPORTED_PROFILE_ANALYSIS_CHOICE_TITLE",
  IMPORTED_PROFILE_ANALYSIS_CHOICE_DETECTION_TITLE:
    "IMPORTED_PROFILE_ANALYSIS_CHOICE_DETECTION_TITLE",
  IMPORTED_PROFILE_ANALYSIS_CHOICE_DETECTION_FLOW:
    "IMPORTED_PROFILE_ANALYSIS_CHOICE_DETECTION_FLOW",
  IMPORTED_PROFILE_ANALYSIS_CHOICE_DEEP_LOCKED: "IMPORTED_PROFILE_ANALYSIS_CHOICE_DEEP_LOCKED",
  IMPORTED_PROFILE_ANALYSIS_AVAILABLE: "IMPORTED_PROFILE_ANALYSIS_AVAILABLE",
  IMPORTED_PROFILE_ANALYSIS_UNIT: "IMPORTED_PROFILE_ANALYSIS_UNIT",
  IMPORTED_PROFILE_ANALYSIS_REANALYZE_ALL: "IMPORTED_PROFILE_ANALYSIS_REANALYZE_ALL",
  IMPORTED_PROFILE_ANALYSIS_COST: "IMPORTED_PROFILE_ANALYSIS_COST",
  IMPORTED_PROFILE_ANALYSIS_PREPAID_NOTE: "IMPORTED_PROFILE_ANALYSIS_PREPAID_NOTE",
  IMPORTED_PROFILE_ANALYSIS_MAIL_INFO: "IMPORTED_PROFILE_ANALYSIS_MAIL_INFO",
  IMPORTED_PROFILE_ANALYSIS_CONFIRM: "IMPORTED_PROFILE_ANALYSIS_CONFIRM",
  IMPORTED_PROFILE_ANALYSIS_CHOICE_EXTENSION_TITLE:
    "IMPORTED_PROFILE_ANALYSIS_CHOICE_EXTENSION_TITLE",
  IMPORTED_PROFILE_ANALYSIS_CHOICE_EXTENSION_FLOW:
    "IMPORTED_PROFILE_ANALYSIS_CHOICE_EXTENSION_FLOW",
  IMPORTED_PROFILE_EXTENSION_GUIDE_TITLE: "IMPORTED_PROFILE_EXTENSION_GUIDE_TITLE",
  IMPORTED_PROFILE_EXTENSION_GUIDE_STEP_1: "IMPORTED_PROFILE_EXTENSION_GUIDE_STEP_1",
  IMPORTED_PROFILE_EXTENSION_GUIDE_STEP_2: "IMPORTED_PROFILE_EXTENSION_GUIDE_STEP_2",
  IMPORTED_PROFILE_EXTENSION_GUIDE_STEP_3: "IMPORTED_PROFILE_EXTENSION_GUIDE_STEP_3",
  IMPORTED_PROFILE_EXTENSION_GUIDE_BILLING: "IMPORTED_PROFILE_EXTENSION_GUIDE_BILLING",
  IMPORTED_PROFILE_EXTENSION_GUIDE_BTN: "IMPORTED_PROFILE_EXTENSION_GUIDE_BTN",
  PROSPECT_ACTION_PROFILE_VISITED: "PROSPECT_ACTION_PROFILE_VISITED",
  PROSPECT_ACTION_POST_COMMENTED: "PROSPECT_ACTION_POST_COMMENTED",
  PROSPECT_ACTION_CONNECTION_SENT: "PROSPECT_ACTION_CONNECTION_SENT",
  PROSPECT_ACTION_CONNECTION_ACCEPTED: "PROSPECT_ACTION_CONNECTION_ACCEPTED",
  PROSPECT_ACTION_MESSAGE_SENT: "PROSPECT_ACTION_MESSAGE_SENT",
  PROSPECT_ACTION_FOLLOW_UP_SENT: "PROSPECT_ACTION_FOLLOW_UP_SENT",
  PROSPECT_ACTION_REPLY_RECEIVED: "PROSPECT_ACTION_REPLY_RECEIVED",
  PROSPECT_ACTION_EMAIL_SENT: "PROSPECT_ACTION_EMAIL_SENT",
  PROSPECT_ACTION_CALL_MADE: "PROSPECT_ACTION_CALL_MADE",
  PROSPECT_ACTION_CALL_BOOKED: "PROSPECT_ACTION_CALL_BOOKED",
  PROSPECT_ACTION_CALL_DONE: "PROSPECT_ACTION_CALL_DONE",
  PROSPECT_ACTION_CUSTOM: "PROSPECT_ACTION_CUSTOM",
  PROSPECT_ACTION_SEARCH_PLACEHOLDER: "PROSPECT_ACTION_SEARCH_PLACEHOLDER",
  PROSPECT_ACTION_SEARCH_EMPTY: "PROSPECT_ACTION_SEARCH_EMPTY",
  PROSPECT_ACTION_CREATE_TYPE: "PROSPECT_ACTION_CREATE_TYPE",
  PROSPECT_ACTION_CREATE_TYPE_TITLE: "PROSPECT_ACTION_CREATE_TYPE_TITLE",
  PROSPECT_ACTION_CREATE_TYPE_INFO: "PROSPECT_ACTION_CREATE_TYPE_INFO",
  PROSPECT_ACTION_CREATE_TYPE_LABEL: "PROSPECT_ACTION_CREATE_TYPE_LABEL",
  PROSPECT_ACTION_CREATE_TYPE_PLACEHOLDER: "PROSPECT_ACTION_CREATE_TYPE_PLACEHOLDER",
  PROSPECT_ACTION_CREATE_TYPE_CTA: "PROSPECT_ACTION_CREATE_TYPE_CTA",
  PROSPECT_ACTION_OPEN_HISTORY: "PROSPECT_ACTION_OPEN_HISTORY",
  PROSPECT_ACTION_CONFIRM_CTA: "PROSPECT_ACTION_CONFIRM_CTA",
  PROSPECT_ACTION_DATE_LABEL: "PROSPECT_ACTION_DATE_LABEL",
  PROSPECT_ACTION_NOTE_LABEL: "PROSPECT_ACTION_NOTE_LABEL",
  PROSPECT_ACTION_NOTE_PLACEHOLDER: "PROSPECT_ACTION_NOTE_PLACEHOLDER",
  PROSPECT_ACTION_FILTER_ALL: "PROSPECT_ACTION_FILTER_ALL",
  PROSPECT_ACTION_FILTER_NONE: "PROSPECT_ACTION_FILTER_NONE",
  PROSPECT_ACTION_HISTORY_EMPTY: "PROSPECT_ACTION_HISTORY_EMPTY",
  PROSPECT_ACTION_HISTORY_LAST: "PROSPECT_ACTION_HISTORY_LAST",
  PROSPECT_ACTION_HISTORY_EDIT: "PROSPECT_ACTION_HISTORY_EDIT",
  PROSPECT_ACTION_HISTORY_DELETE: "PROSPECT_ACTION_HISTORY_DELETE",
  PROSPECT_ACTION_HISTORY_DELETE_TITLE: "PROSPECT_ACTION_HISTORY_DELETE_TITLE",
  PROSPECT_ACTION_HISTORY_DELETE_TEXT: "PROSPECT_ACTION_HISTORY_DELETE_TEXT",
  PROSPECT_SEARCH_FILTER_STATUS: "PROSPECT_SEARCH_FILTER_STATUS",
  PROSPECT_SEARCH_FILTER_ACTION: "PROSPECT_SEARCH_FILTER_ACTION",
  PROSPECT_DETAIL_TAB_HISTORY: "PROSPECT_DETAIL_TAB_HISTORY",
} as const;
